import { combineReducers } from "redux";
import { reducer as formReducer } from 'redux-form';
import { snackbarReducer } from 'react-redux-snackbar';
import { loadingBarReducer } from 'react-redux-loading-bar';
import Login from './LoginReducer'
import Forget from './ForgetReducer'
import Register from './RegisterReducer'


export default combineReducers({
   form: formReducer,
   login: Login,
   forget: Forget,
   snackbar: snackbarReducer,
   loadingBar: loadingBarReducer,
   register: Register 
   
});
